import { useMemo } from 'react';

import { Grid, Typography } from '@mui/material';
import TextDisplayBlock from '@apigrowfinance/pbolt-text-display-block';
import { useTheme } from '@apigrowfinance/pbolt-theme-provider';
import { FormattedMessage, useIntl } from 'react-intl';

import { TransactionMerchant } from '@clients/transactionsClient';

interface TransactionMerchantDetailsProps {
    merchant: TransactionMerchant;
    isLoading?: boolean;
}

const TransactionMerchantDetails = ({
    merchant,
    isLoading,
}: TransactionMerchantDetailsProps) => {
    const { theme } = useTheme();
    const { formatMessage } = useIntl();
    const textBlocks = useMemo(() => {
        return [
            {
                label: formatMessage({
                    id: 'TransactionMerchantDetails.name',
                    defaultMessage: 'Name',
                }),
                value: merchant?.name,
            },
            {
                label: formatMessage({
                    id: 'TransactionMerchantDetails.merchantId',
                    defaultMessage: 'ID',
                }),
                value: merchant?.id,
            },
            {
                label: formatMessage({
                    id: 'TransactionMerchantDetails.type',
                    defaultMessage: 'Type',
                }),
                value: merchant?.type,
            },
            {
                label: formatMessage({
                    id: 'TransactionMerchantDetails.city',
                    defaultMessage: 'City',
                }),
                value: merchant?.city,
            },
            {
                label: formatMessage({
                    id: 'TransactionMerchantDetails.country',
                    defaultMessage: 'Country',
                }),
                value: merchant?.state,
            },
            {
                label: formatMessage({
                    id: 'TransactionMerchantDetails.categoryCode',
                    defaultMessage: 'Category Code',
                }),
                value: merchant?.category?.code,
            },
            {
                label: formatMessage({
                    id: 'TransactionMerchantDetails.categoryDescription',
                    defaultMessage: 'Category Description',
                }),
                value: merchant?.category?.description,
            },
            {
                label: formatMessage({
                    id: 'TransactionMerchantDetails.groupName',
                    defaultMessage: 'Group Name',
                }),
                value: merchant?.category?.group_name,
            },
            {
                label: formatMessage({
                    id: 'TransactionMerchantDetails.networkName',
                    defaultMessage: 'Network Name',
                }),
                value: merchant?.category?.network_group,
            },
        ];
    }, [formatMessage, merchant]);
    return (
        <Grid
            container
            item
            flexDirection="column"
            xs={12}
            sx={{
                bgcolor: theme?.palette?.background?.paper,
                pt: 4.375,
                pl: 2.625,
                py: 4,
                px: 3,
                mb: 0.25,
            }}>
            <Typography variant="h6" component="h3">
                <FormattedMessage
                    id="TransactionMerchantDetails.MerchantDetails"
                    defaultMessage="Merchant Details"
                />
            </Typography>
            <Grid item>
                <TextDisplayBlock
                    isLoading={isLoading}
                    textBlocks={textBlocks}
                />
            </Grid>
        </Grid>
    );
};

export default TransactionMerchantDetails;
